module.exports = new __parcel__URL__("BrickWorldFilmFestival.fb3abce2.webp").toString();